<template>
  <div
    class="d-flex-row justify-center align-center shell mx-auto"
    role="button"
    tabindex="0"
    :title="'前往' + item.tree_name"
    @click="toDetail(item)"
    @keypress="toDetail(item)"
  >
    <div class="item ma-auto">
      <div class="avatar-img">
        <img loading="lazy" :src="SYS.setImg(item)" alt="" />
        <!-- :alt="item.tree_name + '圖'" -->
      </div>
    </div>
    <div class="mx-auto my-3 ct-text-subtitle2 mx-auto">
      {{ item.tree_name }}
    </div>
    <div class="mx-auto my-3 ct-text-14 mx-auto titleGray--text">
      {{ item.tree_name_eng }}
    </div>
  </div>
</template>
<script>
export default {
  props: {
    item: {
      type: Object,
      default() {
        return {
          tree_name: "",
          tree_name_eng: ""
        };
      }
    }
  },
  methods: {
    toDetail(item) {
      this.$router.push({
        name: "Book-Detail",
        params: {
          item,
          subject: this.subject
        },
        query: {
          name: item.tree_id
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.shell {
  background: rgba(255, 248, 239, 0.6);
  border-radius: 5px;
  margin: 12px;
  min-height: 284px;
  width: 208px;
  padding: 15px 0px 0px 0px;
  @include phone {
    width: 127px;
    min-height: 197px;
  }
  animation: bounce-in 1s;
  text-align: center;
}

.item {
  cursor: pointer;
  position: relative;
  @include pc {
    height: 150px;
    width: 150px;
  }
  @include phoneAndpad {
    height: 137px;
    width: 137px;
  }
  @include phone {
    width: 97px;
    height: 97px;
  }
  .avatar-img {
    clip-path: circle(50%);
    img {
      object-fit: cover;
      transition: transform 1s, filter 0.5s ease-out;
      @include pc {
        width: 150px;
        height: 150px;
      }
      @include phoneAndpad {
        width: 137px;
        height: 137px;
      }
      @include phone {
        width: 97px;
        height: 97px;
      }
    }
    &:hover {
      img {
        transform: scale(1.5);
      }
    }
    //object-fit: cover;
    @include baseIndex;
    position: absolute;
    border-radius: 40%;
    top: 0;
    left: 0;
    @include pc {
      width: 150px;
      height: 150px;
    }
    @include phoneAndpad {
      width: 137px;
      height: 137px;
    }
    @include phone {
      width: 97px;
      height: 97px;
    }
    // -webkit-mask: url("~@/assets/images/book/book_tree_bg.png") no-repeat center
    //   center/contain;
    // mask: url("~@/assets/images/book/book_tree_bg.png") no-repeat center
    //   center/contain;
  }
  .border-img {
    position: absolute;
    top: 8px;
    left: 6px;
    transform: scale(1.05);
  }
}

@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}
</style>
